import { render, staticRenderFns } from "./pdf-render-annotation.html?vue&type=template&id=f33d43ac&scoped=true&external"
import script from "./pdf-render-annotation.js?vue&type=script&lang=js&external"
export * from "./pdf-render-annotation.js?vue&type=script&lang=js&external"
import style0 from "./pdf-render-annotation.scss?vue&type=style&index=0&id=f33d43ac&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f33d43ac",
  null
  
)

export default component.exports